module.exports = __webpack_public_path__ + "img/01.c75ea3d9.svg";